import { ArrowLeft } from "lucide-react";

export function BackToLanding({ className = "", href = "/", label = "Back to Conferis" }: { className?: string; href?: string; label?: string }) {
  return (
    <a className={`back-to-landing ${className}`.trim()} href={href}>
      <ArrowLeft aria-hidden="true" size={15} />
      {label}
    </a>
  );
}
